import fetcher from '../fetcher';

export type GroupMenu = {
	id: string;
	masterGroupId: string;
	masterMenuId: string;
	isActive: boolean;
	createdBy: string;
	createdDate: string;
	modifiedBy?: string;
	modifiedDate: string;
};

export type GroupMenuPayload = {
	masterGroupId: string;
	masterMenuIds: string[];
	isActive: boolean;
};

export type GroupMenuUpdatePayload = Omit<GroupMenuPayload, 'masterMenuIds'> & {
	id: string;
	masterMenuId: string;
};

export const getGroupMenus = () => {
	return fetcher<GroupMenu[]>({
		api: '/groupmenus/get-all-group-menu',
	});
};

export const getGroupMenu = (id: string) => {
	return fetcher<GroupMenu>({
		api: '/groupmenus/get-group-menu',
		body: {
			id,
		},
	});
};

export const createGroupMenu = (payload: GroupMenuPayload) => {
	return fetcher<string>({
		api: '/groupmenus/create-group-menu',
		body: payload,
	});
};

export const updateGroupMenu = (payload: GroupMenuUpdatePayload) => {
	return fetcher<string>({
		api: '/groupmenus/update-group-menu',
		body: payload,
	});
};
